import { triggerDataLoaded } from "@/components/ScrollRestoration";
import { useState, useEffect } from "react";
import { toast } from "sonner";

interface ApiResponse<T = any> {
  data: T;
  success: boolean;
  message?: string;
}

export const useFetch = <T = any,>(
  fetchFn: () => Promise<ApiResponse<T>>,
  dependencies: any[] = [],
) => {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    // Check if any required params are missing or falsy
    if (dependencies.some((param) => !param)) {
      setLoading(false);
      return;
    }

    setError(null);

    try {
      const response = await fetchFn();

      if (response.success) {
        setData(response.data);
        triggerDataLoaded();
      } else {
        setError(response.message || "Failed to fetch data");
        // toast.error(response.message || "Failed to fetch data");
      }
    } catch (err: any) {
      setError(err.message || "An unexpected error occurred");
      // toast.error(err.message || "An unexpected error occurred");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, dependencies);

  return {
    data,
    loading,
    error,
    refetch: fetchData,
  };
};
